<div class="saml-login">
  <emperor-card [type]="EmperorCardTypes.Outlined">
    <emperor-card-content>
      <div class="logo">
        <img
          src="/assets/images/logo-text-medium.svg"
          alt="bold penguin logo"
        />
      </div>
      <emperor-button
        class="emperor-ui-manually-set-size"
        (click)="gotoSamlAuth()"
        >Sign In</emperor-button
      >
    </emperor-card-content>
  </emperor-card>
</div>
